import { render, staticRenderFns } from "./BlogDetailsRightSidebar.vue?vue&type=template&id=4ea44605&"
import script from "./BlogDetailsRightSidebar.vue?vue&type=script&lang=js&"
export * from "./BlogDetailsRightSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports